import React, { useState } from "react";
import "./Select.scss";

const className = "select";

const Select = ({ options, value, handleClick, long }) => {
  const [clicked, setClicked] = useState(false);

  return (
    <div className={className} onClick={() => setClicked(!clicked)}>
      <div className={className + "-main"}>
        <div className={className + "-head"}>{value}</div>
        <div
          className={`${clicked ? "selectShow select-menu" : "select-menu"} ${
            long ? "longSelect" : ""
          }`}
        >
          {options.map((el, index) => (
            <div
              key={index}
              className={className + "-menuItem"}
              onClick={() => {
                setClicked(false), handleClick(el);
              }}
            >
              {el}
            </div>
          ))}
        </div>
      </div>
      <div className={className + "-icon"}>
        <span
          className={
            clicked ? "material-icons select-active" : "material-icons"
          }
        >
          expand_more
        </span>
      </div>
    </div>
  );
};

export default Select;
